// extracted by mini-css-extract-plugin
export default {"wrapper":"ClearAllFilters_wrapper__MdoV7"};